import { c as _c } from "react/compiler-runtime";
import { Flex, FlexCenter, FlexColumn, TextLabel } from "@opensea/ui-kit";
import { ArrowRightAlt } from "@opensea/ui-kit/icons";
import { useTranslations } from "use-intl";
import { useSnapshot } from "valtio";
import { Button } from "../../../components/Button";
import { useAddress, useIsConnecting } from "../../../polychain/hooks";
import { FlowState } from "../../../stores/flowStore";
import { PaymentMethodOptions, PaymentMethodOptionsCard, PaymentMethodOptionsWalletOptions } from "../PaymentMethodOptions";
export const PaymentMethodStep = t0 => {
  const $ = _c(37);
  const {
    paymentMethod,
    cardDisabledReason,
    setPaymentMethod,
    onProceedToPayment
  } = t0;
  const t = useTranslations("wallet.PaymentMethodStep");
  const address = useAddress();
  const isConnecting = useIsConnecting();
  const {
    flow
  } = useSnapshot(FlowState);
  let t1;
  if ($[0] !== t) {
    t1 = t("paymentMethod");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <TextLabel size="xs">{t1}</TextLabel>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ArrowRightAlt size={16} />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("selectWallet");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <TextLabel color="text-primary" size="xs">{t4}</TextLabel>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t5) {
    t6 = <FlexCenter className="mb-6 gap-2 text-text-secondary">{t2}{t3}{t5}</FlexCenter>;
    $[9] = t2;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== address || $[13] !== cardDisabledReason || $[14] !== flow?.type || $[15] !== paymentMethod) {
    t7 = flow?.type === "checkout" && address && <PaymentMethodOptionsCard disabledReason={cardDisabledReason} selected={paymentMethod === "card"} />;
    $[12] = address;
    $[13] = cardDisabledReason;
    $[14] = flow?.type;
    $[15] = paymentMethod;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== paymentMethod) {
    t8 = <PaymentMethodOptionsWalletOptions selectedPaymentMethod={paymentMethod} />;
    $[17] = paymentMethod;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== paymentMethod || $[20] !== setPaymentMethod || $[21] !== t7 || $[22] !== t8) {
    t9 = <PaymentMethodOptions paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod}>{t7}{t8}</PaymentMethodOptions>;
    $[19] = paymentMethod;
    $[20] = setPaymentMethod;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const t10 = !paymentMethod;
  let t11;
  if ($[24] !== t) {
    t11 = t("save");
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== isConnecting || $[27] !== onProceedToPayment || $[28] !== t10 || $[29] !== t11) {
    t12 = <Flex className="justify-end"><Button className="mt-6" disabled={t10} isLoading={isConnecting} onClick={onProceedToPayment} size="sm">{t11}</Button></Flex>;
    $[26] = isConnecting;
    $[27] = onProceedToPayment;
    $[28] = t10;
    $[29] = t11;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t12 || $[32] !== t9) {
    t13 = <FlexColumn className="w-full min-w-0">{t9}{t12}</FlexColumn>;
    $[31] = t12;
    $[32] = t9;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t13 || $[35] !== t6) {
    t14 = <>{t6}{t13}</>;
    $[34] = t13;
    $[35] = t6;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  return t14;
};